import { render, staticRenderFns } from "./TopChannelsCard.vue?vue&type=template&id=76cdb9e3"
import script from "./TopChannelsCard.vue?vue&type=script&lang=js"
export * from "./TopChannelsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports